export default __webpack_public_path__ + "static/layout-anatomy-light-b065130a5b8f76b2a0fc256bd6ce8fb188f186c059a6c0cd51dcc39b49c360b0.png";